export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg leading-none">桔</span>
              <span className="text-xl font-heading text-background-50">桔子影视</span>
            </div>
            <p className="text-xs text-background-400 leading-relaxed mb-4">
              桔子影视电视剧大全收录最新热播剧集高清全集资源，免费在线观看不缓冲，追剧首选平台。
              每日同步更新国产剧、韩剧、美剧、日剧等海量内容，高清画质畅快追剧。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#ranking" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热播榜单</a>
              <a href="#carousel" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">焦点专题</a>
              <a href="#index" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">专题索引</a>
              <a href="#cards" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">精选推荐</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">帮助与支持</h4>
            <div className="flex flex-col gap-2">
              <a href="#faq" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问答</a>
              <a href="#about" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
              <a href="#contact" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
              <a href="#app" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">移动客户端</a>
              <a href="#features" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">核心优势</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
            <div className="flex flex-col gap-2">
              <span className="text-xs text-background-500">更多合作伙伴即将入驻</span>
            </div>

            <h4 className="text-sm font-semibold text-background-100 mb-4 mt-6">内容分类</h4>
            <div className="flex flex-wrap gap-2">
              <span className="px-2 py-1 rounded bg-background-800 text-[10px] text-background-400 whitespace-nowrap">国产剧</span>
              <span className="px-2 py-1 rounded bg-background-800 text-[10px] text-background-400 whitespace-nowrap">韩剧</span>
              <span className="px-2 py-1 rounded bg-background-800 text-[10px] text-background-400 whitespace-nowrap">美剧</span>
              <span className="px-2 py-1 rounded bg-background-800 text-[10px] text-background-400 whitespace-nowrap">日剧</span>
              <span className="px-2 py-1 rounded bg-background-800 text-[10px] text-background-400 whitespace-nowrap">古装</span>
              <span className="px-2 py-1 rounded bg-background-800 text-[10px] text-background-400 whitespace-nowrap">悬疑</span>
              <span className="px-2 py-1 rounded bg-background-800 text-[10px] text-background-400 whitespace-nowrap">科幻</span>
              <span className="px-2 py-1 rounded bg-background-800 text-[10px] text-background-400 whitespace-nowrap">动画</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[11px] text-background-500 text-center sm:text-left">
            &copy; 2020-2026 桔子影视 JuziTV. All Rights Reserved. 桔子影视电视剧大全 | 热播剧高清免费在线看
          </p>
          <div className="flex items-center gap-4">
            <span className="text-[11px] text-background-500 whitespace-nowrap">用户协议</span>
            <span className="text-[11px] text-background-500 whitespace-nowrap">隐私政策</span>
            <span className="text-[11px] text-background-500 whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}